import store from "../index.js";
import api from "../../utils/api.js";

export const modules = {
  store,
};

export const state = {
  _item: {
    address: "",
  },
  _items: [],
};

export const mutations = {
  setIros(state, item) {
    state._item = {};
    state._item = Object.assign({}, item);
  },
  setIrosList(state, items) {
    state._items = [];
    state._items = Object.assign([], items);
  },
  setIrosListEmpty(state) {
    state._items = [];
  },
};

export const actions = {
  async acIros({ commit }, params) {
    console.log("iros", params);
    try {
      const url = `/api/v1/address-iros?address=${params[0]}&address_jibun=${params[1]}&building_name=${params[2]}&building_dong=${params[3]}&building_ho=${params[4]}&joint_yn=${params[4]}`;
      const res = await api.get(url, { withCredentials: true });

      if (
        res.data?.data &&
        res.data?.data?.address &&
        res.data?.data?.address !== undefined &&
        res?.data?.data?.address !== "undefined" &&
        res?.data?.data?.uniqueNo?.length > 0
      ) {
        commit("setIros", res.data.data);
        return true;
      } else {
        const item = {
          address: `${params[0]} ${params[2] ? params[2] : ""} ${params[3] ? params[3] : ""} ${
            params[4] ? params[4] : ""
          }`,
          dong: "",
          type: "",
          uniqueNo: "",
        };
        commit("setIros", item);
        return false;
      }
    } catch (error) {
      const item = {
        address: `${params[0]} ${params[2] ? params[2] : ""} ${params[3] ? params[3] : ""} ${
          params[4] ? params[4] : ""
        }`,
        dong: "",
        type: "",
        uniqueNo: "",
      };
      commit("setIros", item);
      console.log("acIros error message", error.message);
      return false;
    }
  },
  async acIrosList({ commit }, address) {
    try {
      commit("setIrosListEmpty");
      const url = `/api/v1/address-iros/addresses?address=${address}`;
      const res = await api.get(url);

      console.log("acEstateCode", res.data.data);
      commit("setIrosList", res.data.data);
      return true;
    } catch (error) {
      commit("setIrosListEmpty");
      return false;
    }
  },
  // payload: string(기존 호환, dataList 반환) | {keyword, page}(전체 응답 반환 — 페이지네이션용)
  async acIrosRenewalList(_, payload) {
    const isObj = typeof payload === "object" && payload !== null;
    const keyword = isObj ? payload.keyword : payload;
    const page = isObj && payload.page ? payload.page : 1;
    try {
      const url = `/api/v1/address-iros/unique-nos?address=${encodeURIComponent(
        keyword,
      )}&page=${page}`;
      const res = await api.get(url);
      if (res.data?.code === 1000) return "inspection_time";
      if (res.data?.code !== 0) return null;
      return isObj ? res.data.data || null : res.data.data?.dataList || null;
    } catch (error) {
      return null;
    }
  },
  // 건물명(한글만)으로 등기소 단지 리스트 검색 — NZSC-3189
  // 간편검색은 '한글+숫자' 필수라 건물명 단독 검색이 막혀 있어 별도 엔드포인트 사용
  async acIrosBuildingComplexes(_, keyword) {
    try {
      const url = `/api/v1/address-iros/building-complexes?keyword=${encodeURIComponent(keyword)}`;
      const res = await api.get(url);
      if (res.data?.code === 1000) return "inspection_time";
      return res.data?.code === 0 ? res.data.data?.complexes || [] : [];
    } catch (error) {
      return [];
    }
  },
  // 단지 + 동/호 → 등기 유닛(고유번호) 확정 — NZSC-3189
  async acIrosBuildingUnits(_, { dong, lotNo, buldName, buldNo, roomNo }) {
    try {
      const params = new URLSearchParams({
        dong: dong || "",
        lot_no: lotNo || "",
        buld_name: buldName || "",
        buld_no: buldNo || "",
        room_no: roomNo || "",
      });
      const url = `/api/v1/address-iros/building-unit?${params.toString()}`;
      const res = await api.get(url);
      if (res.data?.code === 1000) return "inspection_time";
      return res.data?.code === 0 ? res.data.data?.units || [] : [];
    } catch (error) {
      return [];
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
